/* KOVARO — Merkliste (Favorites).
   Speichert Produkt-Handles in localStorage. Haengt die Herz-Buttons selbst an
   jede Produktkarte (eigene .kvr-card + Dawn .card-wrapper), damit keine
   Theme-Templates angefasst werden muessen. Zaehler am Header-Herz. */
(function () {
  if (window.__kvrFav) return; window.__kvrFav = true;
  var KEY = 'kvr_favs';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} syncAll(); }
  function has(h) { return get().indexOf(h) > -1; }
  function toggle(h) {
    var a = get(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    save(a);
    return i === -1;                       /* true = jetzt gemerkt */
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = href.split('?')[0].split('#')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var HEART = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.6S4.3 15.9 2.6 11.4A4.9 4.9 0 0 1 12 7.3a4.9 4.9 0 0 1 9.4 4.1c-1.7 4.5-9.4 9.2-9.4 9.2z"/></svg>';

  /* --- Header-Zaehler --- */
  function badge() {
    var n = get().length;
    document.querySelectorAll('.kvr-fav').forEach(function (el) {
      var b = el.querySelector('.kvr-fav-count');
      if (!b) { b = document.createElement('span'); b.className = 'kvr-fav-count'; el.appendChild(b); }
      b.textContent = n > 99 ? '99+' : n;
      b.hidden = n === 0;
    });
  }

  /* --- Buttons an Produktkarten haengen --- */
  function inject(root) {
    var cards = (root || document).querySelectorAll('.kvr-card, .card-wrapper');
    cards.forEach(function (card) {
      if (card.__kvrFav) return;
      var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      var h = handleFromHref(link && link.getAttribute('href'));
      if (!h) return;
      card.__kvrFav = true;
      var media = card.querySelector('.kvr-card__media, .card__inner, .card__media') || card;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kvr-fav-btn';
      b.setAttribute('data-kvr-fav', h);
      b.setAttribute('aria-label', 'Save to favourites');
      b.innerHTML = HEART;
      media.appendChild(b);
    });
    syncButtons();
  }

  function syncButtons() {
    document.querySelectorAll('[data-kvr-fav]').forEach(function (b) {
      var on = has(b.getAttribute('data-kvr-fav'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function syncAll() { badge(); syncButtons(); }

  /* --- Klick (delegiert, funktioniert auch fuer spaeter geladene Karten) --- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kvr-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var added = toggle(b.getAttribute('data-kvr-fav'));
    b.classList.toggle('is-on', added);
    b.setAttribute('aria-pressed', added ? 'true' : 'false');
    if (added) { b.classList.remove('kvr-pop'); void b.offsetWidth; b.classList.add('kvr-pop'); }
    document.dispatchEvent(new CustomEvent('kvr:favchange', { detail: { handle: b.getAttribute('data-kvr-fav'), added: added } }));
  });

  window.kvrFav = { get: get, has: has, toggle: toggle, sync: syncAll, inject: inject };

  function init() {
    inject();
    badge();
    /* Karten, die Dawn nachlaedt (Filter/Paginierung) */
    if (window.MutationObserver) {
      new MutationObserver(function () { inject(); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
